// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staking_page_wrapper {
    width: 100%;
    padding: 60px 0px;
    color: #e0e0e0;
    background-color: #181a20;
}

body.light_theme .staking_page_wrapper {
    background-color: #fff;
    color: #1a1a1a;
}

.staking_page_wrapper .container {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
}

.staking_bnr_cnt {
    justify-content: space-between;
    align-items: center;
    gap: 32px;
    margin-bottom: 60px;
}

.staking_title {
    font-size: 48px;
    font-weight: 700;
    margin: 0;
}


.staking_page_wrapper .convert-page__faqSection {
    padding: 0px 0px 50px;
}

.staking_page_wrapper p.staking_desc {
    font-size: 18px;
    color: #84888C;
    font-weight: 500;
    margin-top: 15px;
}

.staking_page_wrapper .staking_btn {
    padding-top: 15px;
}

.staking_page_wrapper .staking_btn button {
    font-size: 15px;
    color: #ffffff;
    background-color: #2b3138;
    border-radius: 50px;
    padding: 16px 24px;
    font-weight: 500;
    border: none;
    cursor: pointer;
}

body.light_theme .staking_page_wrapper .staking_btn button {
    color: #070808;
    background-color: #F5F6F7;
}

.staking_page_wrapper .staking_btn button.loginbtn {
    background-color: #303236;
    color: #fff;
}

.staking_img {
    max-width: 450px;
}

.staking_info_section {
    margin: 100px 0px 70px;
}

.staking_info_title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 32px;
    color: #e6e6e6;
}

body.light_theme .staking_info_title {
    color: #070808;
}

.staking_info_cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    padding-top: 25px;
}

.staking_info_card {
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 85px;
}

.staking_info_icon {
    width: 80px;
    height: 80px;
    border: 1px solid #EFDEC2;
    margin-bottom: 24px;
    border-radius: 50%;
    box-shadow: 0px 1px 10px #0000001c;
    display: flex;
    align-items: center;
    justify-content: center;
}

.staking_info_card .number {
    font-size: 60px;
    color: #F3EBDF;
    font-weight: 700;
    position: absolute;
    left: 0px;
}

.staking_info_icon img {
    object-fit: contain;
}

.staking_info_card h3 {
    font-size: 20px;
    font-weight: 600;
    color: #e1e1e1;
    margin: 0 0 12px 0;
}

body.light_theme .staking_info_card h3 {
    color: #111;
}

.staking_info_card p {
    font-size: 16px;
    color: #84888C;
    line-height: 1.5;
    margin: 0;
}

.nextarrow_step {
    font-size: 36px;
    color: #E5E7EB;
    position: absolute;
    right: -20px;
    font-weight: 200;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 10;
}

.staking_products_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}

.staking_products_header h2 {
    font-size: 28px;
    font-weight: 700;
    margin: 0;
    color: #e7e7e7;
}

body.light_theme .staking_products_header h2 {
    color: #111;
}

.staking_products_filters {
    display: flex;
    align-items: center;
    gap: 24px;
}

.staking_checkbox_label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    color: #dbdbdb;
    cursor: pointer;
}

body.light_theme .staking_checkbox_label {
    color: #070808;
}

.staking_checkbox_label input {
    width: 16px;
    height: 16px;
    accent-color: #333;
    cursor: pointer;
}

.staking_search_bar {
    display: flex;
    align-items: center;
    background-color: #f6f6f724;
    border-radius: 6px;
    padding: 8px 16px;
    gap: 10px;
    width: 240px;
}

body.light_theme .staking_search_bar {
    background-color: #F6F6F7;
}

.staking_search_bar input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 14px;
    width: 100%;
    color: #dadada;
}

body.light_theme .staking_search_bar input {
    color: #111;
}

.staking_search_bar input::placeholder {
    color: #a0a5aa;
}

.staking_table_container {
    width: 100%;
    overflow-x: auto;
}

.staking_table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

.staking_table th {
    padding: 16px;
    color: #848e9c;
    font-size: 12px;
    font-weight: 400;
}

.staking_table th .sort_icon {
    font-size: 10px;
    margin-left: 4px;
    color: #a0a5aa;
}

.staking_table td {
    padding: 24px 16px;
    /* border-bottom: 1px solid #f5f6f7; */
    font-size: 16px;
    font-weight: 500;
    color: #e0e0e0;
}

body.light_theme .staking_table td {
    color: #1e2329;
}

.staking_table .action_th,
.staking_table .action_td {
    text-align: right;
    width: auto;
    float: right;
}

.coin_cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.coin_icon_stak {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    font-size: 14px;
}

.staking_page_wrapper .coin_name {
    font-weight: 500;
    color: #ececec;
    font-size: 16px;
}

body.light_theme .staking_page_wrapper .coin_name {
    color: #070808;
}

.staking_page_wrapper .coin_badge {
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 600;
}

.badge_bonus {
    background-color: #8FFCDE;
    color: #000000;
}

.badge_vip {
    background-color: #FFD98F;
    color: #000000;
}

.badge_new {
    background-color: #52FFB1;
    color: #000000;
}

.fire_icon {
    font-size: 14px;
}

.apr_cell {
    font-weight: 600;
    color: #1e2329;
}

.reward_icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    font-size: 10px;
}

.multiple_rewards {
    display: flex;
    align-items: center;
}

.multiple_rewards .reward_icon {
    margin-left: -8px;
    border: 2px solid white;
}

.multiple_rewards .reward_icon:first-child {
    margin-left: 0;
}

.type_cell {
    font-weight: 600;
    color: #4b4f56;
}

.action_btn {
    background-color: #2b3139;
    color: white;
    border: none;
    padding: 8px 24px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.action_btn:hover {
    background-color: #1e2329;
}

.mobile_action_btns {
    display: none;
}

.staking_pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    gap: 8px;
}

.page_num,
.page_nav {
    background: none;
    border: none;
    font-size: 14px;
    font-weight: 600;
    color: #4b4f56;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
}

.page_num:hover,
.page_nav:hover {
    background-color: #f5f6f7;
}

.page_num.active {
    background-color: #f5f6f7;
    color: #111;
}

/* Why Stake Section */
.why_stake_section_new {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 100px 0px;
}

.why_stake_left {
    flex: 1 1;
}

.why_stake_right {
    flex: 1 1;
    display: flex;
    justify-content: end;
    align-items: center;
}

.why_stake_right img {
    max-width: 240px;
}

.why_stake_cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 30px;
}

.why_stake_card {
    display: flex;
    align-items: center;
    background-color: #fafafa0d;
    border: 1px solid #f3f4f60d;
    padding: 30px;
    position: relative;
    border-radius: 14px;
}

body.light_theme .why_stake_card {
    background-color: #fafafa;
    border: 1px solid #F3F4F6;
}

.why_stake_card::before {
    content: "";
    width: 3px;
    height: 30px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0px;
    left: 0;
    background-color: #C59D5F;
    border-radius: 2px;
    z-index: 999;
}

body.light_theme .why_stake_card_icon {
    border: 1px solid #F3F4F6;
    background-color: white;
}

.why_stake_card_icon {
    width: 50px;
    height: 50px;
    border: 1px solid #505050;
    min-width: 50px;
    background-color: #393939;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

.why_stake_card_icon img {
    width: 28px;
    height: 28px;
    object-fit: contain;
}

.why_stake_card_content h3 {
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 5px 0;
}

.why_stake_card_content p {
    font-size: 13px;
    color: #84888C;
    margin: 0;
}

/* How to Stake Section */
.how_stake_section {
    margin-bottom: 100px;
}

.how_stake_timeline {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: 60px;
    gap: 32px;
}

.timeline_line {
    position: absolute;
    top: 40px;
    left: 10%;
    right: 10%;
    height: 1px;
    border-top: 1px dashed #eaecef;
    background-color: transparent;
    z-index: 1;
}

.timeline_step {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    z-index: 2;
}

.step_icon_container {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
}

.step_icon {
    width: 94px;
    border: 1px solid #c4c6cf42;
    height: 94px;
    background-color: #171a20;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

body.light_theme .step_icon {
    background-color: white;
}

.step_icon img {
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.step_number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #171a20;
    color: #e4e4e4;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    position: absolute;
    top: -8px;
    border: 1px solid #C4C6CF30;
}

body.light_theme .step_number {

    background-color: #F7F9FB;
    color: #292b2f;
}

.timeline_step h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 12px 0;
}

.timeline_step p {
    font-size: 13px;
    color: #84888C;
    margin: 0;
    max-width: 370px;
}



/* Staking Detail / Help Center Layout */
.staking_detail_wrapper {
    width: 100%;
    padding: 40px 0;
    color: #f1f1f1;
    background-color: #181a20;
    min-height: 80vh;
}

body.light_theme .staking_detail_wrapper {
    color: #111;
    background-color: #fff;
}

.staking_detail_wrapper .container {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
}

.hc_breadcrumb {
    font-size: 16px;
    color: #A0A3A7;
    margin-bottom: 40px;
}

.hc_breadcrumb .hc_link {
    cursor: pointer;
}

.hc_breadcrumb .hc_link:hover {
    opacity: 0.8;
}

.hc_breadcrumb .hc_sep {
    margin: 0 8px;
    font-size: 12px;
}

.hc_breadcrumb .hc_current {
    color: #ffffff;
    font-weight: 500;
}

body.light_theme .hc_breadcrumb .hc_current {
    color: #111;
}

.hc_layout {
    display: flex;
    gap: 40px;
}

.hc_sidebar {
    width: 260px;
    flex-shrink: 0;
    border-right: 1px solid #f2f3f42e;
    padding-right: 40px;
}

body.light_theme .hc_sidebar {
    border-right: 1px solid #F2F3F4;
}

.hc_mobile_toggle {
    display: none;
}

.hc_sidebar_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 0;
    font-size: 16px;
    color: #e7e7e7;
    cursor: pointer;
    border-bottom: 1px solid transparent;

}

body.light_theme .hc_sidebar_item {
    color: #484B51;
}

.hc_sidebar_item:hover {
    opacity: 0.8;
}

.hc_sidebar_item .font-weight-bold {
    font-weight: 600;
}

.hc_sidebar_item .text-black {
    color: #111;
}

.hc_chev {
    color: #848e9c;
    transition: transform 0.2s ease;
    transform: rotate(0deg);
}

.hc_chev.open {
    transform: rotate(90deg);
}

.hc_submenu {
    padding-left: 20px;
    margin-top: 8px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.hc_submenu_item {
    font-size: 16px;
    color: #e9e9e9;
    cursor: pointer;
    transition: color 0.2s;
}

body.light_theme .hc_submenu_item {
    color: #484B51;
}

.hc_submenu_item:hover {
    opacity: 0.8;
}

.hc_submenu_item.active_sub {
    font-weight: 600;
    color: #dddddd;
}

.hc_submenu_item.active_sub:hover {
    opacity: 0.8;
}

.hc_main_content {
    flex-grow: 1;
}

.hc_content_section {
    margin-bottom: 18px;
}

.hc_section_header {
    display: flex;
    gap: 24px;
    align-items: center;
    padding-bottom: 16px;
    cursor: pointer;
}

.hc_section_header h2 {
    font-size: 19px;
    font-weight: 600;
    margin: 0;
    color: #e7e7e7;
}

body.light_theme .hc_section_header h2 {
    color: #111;
}

.hc_section_chev {
    color: #e7e7e7;
    transition: transform 0.2s ease;
    transform: rotate(90deg);
}

body.light_theme .hc_section_chev {
    color: #111;
}

.hc_section_chev.open {
    transform: rotate(-90deg);
}

.hc_article_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 40px;
    padding-bottom: 24px;
}

.hc_article_item {
    font-size: 16px;
    line-height: 1.5;
}

.hc_article_item a {
    color: #b3b3b3;
    text-decoration: none;
    transition: color 0.2s;
}

body.light_theme .hc_article_item a {
    color: #4b4f56;
}

.hc_article_item a:hover {
    opacity: 0.8;
}

@media (max-width: 767px) {
    .hc_layout {
        flex-direction: column;
        gap: 30px;
    }

    .hc_mobile_toggle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px;
        background: #393c42;
        border-radius: 8px;
        margin-bottom: 0px;
        cursor: pointer;
    }

    body.light_theme .hc_mobile_toggle {
        background: #f8f9fa;
    }

    .hc_mobile_toggle h2 {
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        color: #e3e3e3;
    }

    body.light_theme .hc_mobile_toggle h2 {
        color: #111;
    }

    .hc_section_header h2 {
        font-size: 16px;
    }

    .hc_article_item {
        font-size: 14px;
    }

    .hc_sidebar {
        display: none;
        width: 100%;
        border-right: none;
        border-bottom: none;
        padding-right: 0;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }


    .hc_sidebar.mobile_open {
        display: block;
    }

    .hc_article_grid {
        grid-template-columns: 1fr;
    }
}

/* Mint Modal styling */
.mint-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    height: 100vh;
    background-color: rgb(255 255 255 / 20%) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
    animation: fadeInModal 0.25s ease-out;
}

.mint-modal-content {
    background-color: #ffffffde !important;
    color: #1e2329 !important;
    width: 95%;
    max-width: 800px;
    border-radius: 12px;
    padding: 24px 32px;
    position: relative;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.20);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

.mint-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.mint-modal-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 20px;
    font-weight: 700;
}

.mint-title-icon {
    width: 24px;
    height: 24px;
}

.mint-modal-close {
    background: transparent;
    border: none;
    padding: 0px;
    font-size: 24px;
    color: #ffffff !important;
    cursor: pointer;
    transition: color 0.2s;
    line-height: 1;
}

body.light_theme .mint-modal-close {
    color: #1e2329 !important;
}

.mint-modal-body {
    display: flex;
    gap: 40px;
}

/* Left Column */
.mint-modal-left {
    flex: 1 1;
}

.mint-info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
}

.mint-info-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.mint-info-label {
    font-size: 13px;
    color: #848e9c !important;
    font-weight: 500;
}

.mint-info-value {
    font-size: 16px;
    font-weight: 600;
    color: #1e2329 !important;
}

.mint-green-text {
    color: #03a66d !important;
}

.mint-section-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
}

.mint-input-box {
    display: flex;
    align-items: center;
    border: 1px solid #eaecef;
    border-radius: 8px;
    padding: 10px 16px;
    transition: border-color 0.2s;
}

.mint-input-box:focus-within {
    border-color: #1a1d21;
}

.mint-input-box input {
    flex: 1 1;
    border: none;
    outline: none;
    font-size: 14px;
    color: #1e2329 !important;
}

.mint-input-addon {
    display: flex;
    align-items: center;
    gap: 12px;
}

.mint-max-btn {
    color: #d1aa67 !important;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
}

.mint-currency-dropdown {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

.mint-amount-details {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 32px;
}

.mint-amount-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.mint-amount-lbl {
    color: #848e9c !important;
}

.mint-amount-val {
    color: #1e2329 !important;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
}

.mint-add-icon {
    font-size: 14px;
    cursor: pointer;
}

.mint-apr-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #eaecef;
    border-radius: 8px;
    padding: 16px;
    font-size: 14px;
    color: #848e9c !important;
}

.mint-apr-box span:last-child {
    font-weight: 600;
    color: #1e2329 !important;
}

/* Right Column */
.mint-modal-right {
    flex: 1 1;
}

.mint-daily-return-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
}

.mint-daily-return-box {
    border: 1px solid #eaecef;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 32px;
}

.mint-return-icon {
    width: 20px;
    height: 20px;
}

.mint-return-val {
    font-size: 14px;
    font-weight: 600;
    color: #12a771 !important;
}

.mint-rules-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    border-bottom: 1px solid #eaecef;
    padding-bottom: 8px;
}

.mint-rules-title {
    font-size: 14px;
    font-weight: 600;
    position: relative;
}

.mint-title-underline {
    position: absolute;
    bottom: -9px;
    left: 0;
    width: 20px;
    height: 3px;
    background-color: #1e2329;
    border-radius: 2px;
}

.mint-rules-link {
    font-size: 13px;
    color: #848e9c !important;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.mint-timeline {
    position: relative;
    padding-left: 12px;
}

.mint-timeline::before {
    content: '';
    position: absolute;
    top: 6px;
    bottom: 20px;
    left: 14px;
    width: 1px;
    background-color: #eaecef;
}

.mint-timeline-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    position: relative;
}

.mint-timeline-item.last {
    margin-bottom: 0;
}

.mint-timeline-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #eaecef;
    margin-top: 6px;
    margin-right: 16px;
    position: relative;
    z-index: 2;
}

.mint-timeline-dot.active {
    background-color: #1e2329;
}

.mint-timeline-dot.icon {
    background-color: transparent;
    margin-top: 2px;
    margin-left: -3px;
    font-size: 14px;
    color: #848e9c;
}

.mint-timeline-content {
    flex: 1 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 13px;
}

.mint-timeline-lbl {
    color: #1e2329 !important;
}

.mint-timeline-val {
    color: #848e9c !important;
    text-align: right;
}

.mint-timeline-val.multi-line {
    line-height: 1.4;
}

/* Footer */
.mint-modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
}

.mint-agreement {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
}

.mint-agreement input {
    cursor: pointer;
}

.mint-agreement label {
    color: #1e2329 !important;
}

.mint-agreement a {
    color: #1e2329 !important;
    text-decoration: underline;
}

.mint-actions {
    display: flex;
    gap: 12px;
}

.mint-btn-cancel {
    background-color: #f5f6f7;
    color: #1e2329 !important;
    border: none;
    border-radius: 8px;
    padding: 10px 24px;
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
}

.mint-btn-confirm {
    background-color: #f5f6f7;
    color: #b7bdc6 !important;
    border: none;
    border-radius: 8px;
    padding: 10px 24px;
    font-weight: 600;
    cursor: not-allowed;
    font-size: 14px;
}

.mint-btn-confirm:not(:disabled) {
    background-color: #1a1d21;
    color: #f3f3f3 !important;
    cursor: pointer;
}

@media (max-width: 767px) {
    .mint-modal-body {
        flex-direction: column;
        gap: 24px;
    }

    .mint-modal-footer {
        flex-direction: column;
        align-items: stretch;
        gap: 20px;
    }

    .mint-actions {
        flex-direction: column;
    }

    .mint-btn-cancel,
    .mint-btn-confirm {
        width: 100%;
    }

    .mint-modal-overlay {
        align-items: end;
    }

    .mint-modal-content {
        width: 100%;
        max-width: 100%;
        border-radius: 12px 12px 0px 0px;
        max-height: 85vh;
        height: auto;
        min-height: 30vh;
        overflow: scroll;
        padding: 20px;
        box-shadow: 0 4px 24px rgb(0 0 0 / 39%);
    }

    .staking_page_wrapper .convert-page__faqSection {
        padding: 0px 0px 20px;
    }


}

/* Tooltip styles */
.mint-tooltip-wrapper {
    position: relative;
    display: inline-block;
    cursor: help;
    border-bottom: 1px dotted #848e9c;
}

.mint-tooltip {
    visibility: hidden;
    opacity: 0;
    width: 320px;
    background-color: #2b3139;
    color: #eaecef;
    text-align: left;
    border-radius: 6px;
    padding: 12px 16px;
    position: absolute;
    z-index: 1000;
    top: 100%;
    left: 0;
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.5;
    transition: opacity 0.2s, visibility 0.2s;
    font-weight: 400;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: none;
}

.mint-tooltip::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 20px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #2b3139 transparent;
}

.mint-tooltip-wrapper:hover .mint-tooltip {
    visibility: visible;
    opacity: 1;
}

/* Intro Modal Styling */
.intro-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgb(255 255 255 / 20%) !important;
    display: flex;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    justify-content: center;
    align-items: center;
    z-index: 100000000;
    animation: fadeInModal 0.25s ease-out;
}

.intro-modal-content {
    background-color: #ffffff !important;
    color: #1e2329 !important;
    width: 95%;
    max-width: 600px;
    border-radius: 12px;
    padding: 24px;
    position: relative;
    box-shadow: 0 4px 24px rgb(0 0 0 / 26%);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

.intro-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.intro-modal-header h2 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    flex: 1 1;
    margin-left: 8px;
}

.intro-back-btn,
.intro-close-btn {
    background: transparent;
    border: none;
    font-size: 20px;
    color: #848e9c !important;
    cursor: pointer;
    line-height: 1;
    padding: 0;
}

.intro-back-btn:hover,
.intro-close-btn:hover {
    color: #1e2329 !important;
}

.intro-back-btn {
    font-size: 24px;
    color: #1e2329 !important;
}

.intro-tabs {
    display: flex;
    gap: 24px;
    border-bottom: 1px solid #eaecef;
    margin-bottom: 24px;
}

.intro-tab {
    font-size: 14px;
    font-weight: 600;
    color: #848e9c !important;
    padding-bottom: 12px;
    cursor: default;
    position: relative;
}

.intro-tab.active {
    color: #1e2329 !important;
}

.intro-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #1e2329;
    border-radius: 2px;
}

.intro-rule-section {
    margin-bottom: 24px;
}

.intro-rule-section h4 {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 12px 0;
    color: #1e2329 !important;
}

.intro-rule-section p {
    font-size: 13px;
    line-height: 1.6;
    color: #848e9c !important;
    margin: 0 0 8px 0;
}

/* Service Fee Dropdown */
.service-fee-container {
    border: 1px solid #eaecef;
    border-radius: 8px;
    margin-top: 12px;
    background-color: #ffffff;
    overflow: hidden;
}

.service-fee-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #848e9c;
    font-size: 13px;
    font-weight: 500;
    padding: 12px;
    cursor: pointer;
}

.service-fee-value {
    color: #1e2329;
    display: flex;
    align-items: center;
    gap: 4px;
}

.service-fee-body {
    padding: 0 12px 12px 12px;
}

.service-fee-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #848e9c;
    font-size: 13px;
    margin-bottom: 8px;
}

.service-fee-row:last-child {
    margin-bottom: 0;
}

/* Tiers Timeline inside APR */
.tier-timeline {
    position: relative;
    padding-left: 6px;
    margin-top: 8px;
}

.tier-timeline::before {
    content: '';
    position: absolute;
    top: 8px;
    bottom: 12px;
    left: 12px;
    width: 1px;
    background-color: #eaecef;
    z-index: 1;
}

.tier-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #1e2329;
    font-size: 13px;
    margin-bottom: 12px;
    position: relative;
    z-index: 2;
}

.tier-item:last-child {
    margin-bottom: 0;
}

.tier-item-left {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #ffffff;
}

.tier-item-left i {
    color: #848e9c;
    font-size: 16px;
}

/* ==========================================================
   Staking Page Projects Tabs (Launchpad style)
   ========================================================== */
.launchpad_projects_tabs {
    display: flex;
    gap: 32px;
    margin-bottom: 20px;
}

.projects_tab {
    background: transparent;
    border: none;
    padding: 0 0 12px 0;
    font-size: 20px;
    font-weight: 600;
    color: #84888C;
    cursor: pointer;
    position: relative;
    transition: color 0.2s;
}

.projects_tab:hover {
    opacity: 0.8;
}

.projects_tab.active {
    color: #ffffff;
    font-weight: 600;
}

body.light_theme .projects_tab.active {
    color: #1E2329;
}

.projects_tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0px;
    margin: 0 auto;
    width: 50%;
    height: 3px;
    background-color: #D4B363;
}

@media (max-width: 767px) {

    .projects_tab {
        font-size: 15px;
    }

    .pool_card {
        padding: 20px;
    }

    .why_stake_card {
        padding: 20px;
    }

    .how_stake_section {
        margin-bottom: 50px;
    }

    .staking_page_wrapper .staking_btn button {
        font-size: 13px;
        padding: 8px 16px;
    }

    .launchpad_projects_tabs {
        gap: 20px;
        margin-bottom: 0px;
    }

    .project_name_badge h3 {
        font-size: 20px;
    }
}

/* ==========================================================
   Project Card Layout Styles (Launchpad Style)
   ========================================================== */
.project_card {
    background-color: #f9fafb0d;
    border-radius: 20px;
    padding: 24px;
    position: relative;
    margin-bottom: 24px;
}

body.light_theme .project_card {
    background-color: #F9FAFB;
}

.project_card_status {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #EBECED;
    color: #84888C;
    font-size: 13px;
    font-weight: 400;
    padding: 1px 12px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 12px;
}

.project_card_inner {
    display: flex;
    gap: 30px;
}

.project_card_left {
    width: 320px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    cursor: pointer;
    transition: transform 0.2s;
}

.project_card_left:hover {
    transform: translateY(-2px);
}

.project_title_sec {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 30px;
}

.project_icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background-color: #1E2329;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.project_icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.project_name_badge h3 {
    font-size: 23px;
    font-weight: 600;
    color: #fff;
    margin: 0;
}

body.light_theme .project_name_badge h3 {
    color: #000;
}

.initial_badge {
    display: inline-block;
    background-color: #89EFF6;
    color: #000000;
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
    margin-top: 4px;
}

.project_info_group {
    margin-bottom: 24px;
}

.project_info_group.mt-auto {
    margin-top: auto;
    margin-bottom: 0;
}

.info_label {
    color: #f0f0f0;
    font-size: 12px;
    margin-bottom: 1px;
}

body.light_theme .info_label {
    color: #84888C;
}

.info_value p {
    color: #e8e8e8;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
}

body.light_theme .info_value p {
    color: #1E2329;
}

.project_card_right {
    flex-grow: 1;
    display: flex;
    gap: 20px;
}

.pool_card {
    background-color: #ffffff12;
    border-radius: 16px;
    border: 1px solid #eaecef1f;
    padding: 24px;
    color: #fff;
    flex: 1 1;
    max-width: calc(50% - 10px);
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

body.light_theme .pool_card {
    background-color: #FFFFFF;
    color: #1a1a1a;
    border: 1px solid #eaecef;
}

.pool_card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
}

.pool_card:only-child {
    max-width: 50%;
}

.pool_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
}

.pool_icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.pool_icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.pool_title h4 {
    font-size: 19px;
    font-weight: 600;
    color: #fff;
    margin: 0;
}

body.light_theme .pool_title h4 {
    color: #000;
}

.pool_stats_row {
    display: flex;
    justify-content: space-between;
}

.stat_label {
    color: #84888C;
    font-size: 12px;
    margin-bottom: 1px;
}

.stat_value {
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}

body.light_theme .stat_value {
    color: #1E2329;
}

.stat_value span {
    font-size: 14px;
    font-weight: 600;
    margin-left: 4px;
}

.pool_summary {
    border-top: 1px solid #F2F3F4;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

body:not(.light_theme) .pool_summary {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.summary_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.summary_label {
    color: #84888C;
    font-size: 12px;
    margin: 0;
}

.summary_value {
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    color: #fff;
}

body.light_theme .summary_value {
    color: #444444;
}

.trade_btn {
    width: 100%;
    margin-top: 24px;
    background-color: #F5F6F7;
    color: #1E2329;
    font-size: 14px;
    font-weight: 500;
    border: none;
    border-radius: 8px;
    padding: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.trade_btn:hover {
    background-color: #EAECEF;
}

@media (max-width: 1024px) {
    .project_card_inner {
        flex-direction: column;
    }

    .project_card_left {
        width: 100%;
        margin-bottom: 20px;
    }

    .project_card_right {
        flex-direction: column;
    }

    .pool_card,
    .pool_card:only-child {
        max-width: 100%;
    }
}

/* Soft Staking Modal Styles */
.ss-modal-content {
    max-width: 440px !important;
}

.ss-modal-body {
    flex-direction: column;
    gap: 16px;
    padding: 10px 0px;
}

.ss-status-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ss-status-label {
    font-size: 15px;
    font-weight: 600;
    color: #eaecef;
}

body.light_theme .ss-status-label {
    color: #1e2329;
}

.ss-status-badge {
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    padding: 3px 10px;
}

.ss-status-badge--enabled {
    color: #03a66d;
    background: rgba(3, 166, 109, 0.18);
}

.ss-status-badge--disabled {
    color: #848e9c;
    background: rgba(132, 142, 156, 0.15);
}

.ss-desc {
    font-size: 13px;
    color: #848e9c;
    margin: 0;
    line-height: 1.6;
}

.ss-error {
    color: #f6465d;
    font-size: 13px;
}

.ss-btn-disable {
    background-color: #f6465d !important;
    border-color: #f6465d !important;
    color: #fff !important;
}

/* Soft Staking Success Modal */
.ss-success-modal {
    max-width: 400px;
}

.ss-success-content {
    padding: 32px 24px;
    text-align: center;
}

.ss-success-icon {
    font-size: 56px;
    line-height: 1;
}

.ss-success-icon.active {
    color: #03a66d;
}

.ss-success-icon.inactive {
    color: #848e9c;
}

.ss-success-title {
    margin: 16px 0 8px;
    font-size: 18px;
    font-weight: 700;
    color: #e0e0e0;
}

body.light_theme .ss-success-title {
    color: #1e2329;
}

.ss-success-desc {
    font-size: 13px;
    color: #848e9c;
    margin: 0 0 24px;
    line-height: 1.6;
}

.ss-success-btn {
    width: 100%;
}


@media (max-width: 1366px) {

    .staking_title {
        font-size: 38px;
    }


}


@media (max-width: 1200px) {

    .staking_title {
        font-size: 32px;
    }

    .staking_img {
        max-width: 300px;
    }


    .staking_page_wrapper .staking_btn button {
        font-size: 14px;
        padding: 10px 20px;
    }

    .why_stake_card_content h3 {
        font-size: 18px;
    }

    .staking_info_title {
        font-size: 24px;
    }

}

@media (max-width: 991px) {

    .staking_info_card .number {
        font-size: 40px;
    }

    .projects_tab {
        font-size: 16px;
    }

    .staking_info_card {
        padding-left: 65px;
    }

    .staking_info_card h3 {
        font-size: 18px;
    }

    .staking_info_card p {
        font-size: 14px;
    }

}



/* Mobile Table and Popup styles */
@media (max-width: 767px) {

    .staking_table th:nth-child(3),
    .staking_table th:nth-child(4),
    .staking_table th:nth-child(5),
    .staking_table td:nth-child(3),
    .staking_table td:nth-child(4),
    .staking_table td:nth-child(5) {
        display: none;
    }

    .why_stake_section_new {
        margin: 40px 0px;
    }

    .staking_table th:nth-child(2),
    .staking_table td:nth-child(2) {
        text-align: right;
    }

    .staking_table th:nth-child(1),
    .staking_table td:nth-child(1) {
        padding-left: 10px;
    }

    .staking_table tbody tr {
        cursor: pointer;
    }

    .projects_tab {
        font-size: 14px;
    }

    .project_card {
        padding: 20px;
    }

    .project_name_badge h3 {
        font-size: 19px;
    }

    .project_icon {
        width: 32px;
        min-width: 32px;
        height: 32px;
    }

    .project_title_sec {
        margin-bottom: 20px;
    }

    .project_info_group {
        margin-bottom: 15px;
    }

    .mobile_staking_popup_overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
        display: flex;
        align-items: flex-end;
    }

    .mobile_staking_popup {
        background: #1e232994 !important;
        -webkit-backdrop-filter: blur(4px);
                backdrop-filter: blur(4px);
        border: 1px solid #ffffff12;
        width: 100%;
        border-radius: 20px 20px 0 0;
        padding: 20px;
        animation: slideUp 0.3s ease;
    }

    body.light_theme .mobile_staking_popup {
        background: #fff !important;
        color: #080808 !important;
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }

    .mobile_staking_popup .popup_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .mobile_staking_popup .popup_header h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
    }

    .mobile_staking_popup .close_btn {
        background: none;
        border: none;
        font-size: 28px;
        color: #84888C;
        cursor: pointer;
    }

    .mobile_staking_popup .popup_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;
        font-size: 15px;
    }

    .mobile_staking_popup .popup_row:last-child {
        border-bottom: none;
    }

    .mobile_staking_popup .popup_row span:first-child {
        color: #84888C;
    }

    .mobile_staking_popup .apr_val {
        color: #fff;
        font-weight: 600;
    }

    body.light_theme .mobile_staking_popup .apr_val {
        color: #111;
    }

    .reward_popup_icons {
        display: flex;
        gap: 6px;
    }

    .reward_popup_icon {
        width: 24px;
        height: 24px;
    }

    .mobile_staking_popup .popup_footer {
        margin-top: 18px;
    }

    .mobile_staking_popup .popup_footer .action_btn {
        font-size: 13px;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        padding: 8px !important;
    }

    .mobile_action_btns {
        display: flex;
        gap: 12px;
        margin-bottom: 20px;
    }

    .softstakingsearch .searchBar.custom-tabs {
        margin: 0px;
    }

}

@media (max-width: 660px) {

    .staking_bnr_cnt {
        flex-direction: column;
        gap: 32px;
        margin-bottom: 40px;
        text-align: center;
    }

    .staking_info_card .number {
        display: none;
    }

    .staking_title {
        font-size: 24px;
    }

    .staking_table td {
        padding: 15px 10px;
        font-size: 14px;
    }

    .staking_page_wrapper .coin_name {
        font-size: 14px;
    }

    .staking_pagination {
        margin-top: 20px;
    }

    .staking_page_wrapper p.staking_desc {
        font-size: 15px;
        margin-top: 10px;
    }

    .staking_img {
        max-width: 240px;
    }


    .staking_page_wrapper {
        padding: 50px 0px;
    }

    .staking_page_wrapper .staking_btn {
        padding-top: 0px;
        justify-content: center;
    }

    .staking_products_header h2 {
        font-size: 20px;
    }

    .staking_products_header {
        align-items: start;
        margin-bottom: 20px;
        gap: 20px;
    }

    .staking_info_cards {
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
    }

    .staking_info_title {
        font-size: 20px;
        margin-bottom: 0px;
        text-align: center;
    }

    .why_stake_section_new {
        flex-direction: column;
        margin-bottom: 50px;
    }

    .why_stake_right {
        margin-top: 32px;
    }

    .why_stake_card_content h3 {
        font-size: 16px;
    }

    .timeline_step {
        display: grid;
        grid-template-columns: 60px 1fr;
        column-gap: 16px;
        row-gap: 6px;
        text-align: left;
    }

    .step_icon_container {
        grid-column: 1;
        grid-row: 1 / span 2;
        margin: 0;
        z-index: 2;
    }

    .step_icon {
        width: 50px;
        height: 50px;
    }

    .step_icon img {
        width: 24px;
        height: 24px;
    }

    .step_number {
        width: 20px;
        height: 20px;
        font-size: 10px;
        top: -6px;
    }

    .timeline_step h3 {
        font-size: 16px;
        margin: 0px;
        align-self: end;
    }

    .timeline_step p {
        max-width: 100%;
        font-size: 13px;
        align-self: start;
        margin: 0;
    }

    .how_stake_section {
        margin-bottom: 40px;
    }

    .how_stake_timeline {
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin-top: 30px;
        position: relative;
    }

    .timeline_line {
        top: 20px;
        bottom: 30px;
        left: 25px;
        width: 1px;
        height: auto;
        right: auto;
        border-top: none;
        border-left: 1px dashed #eaecef;
        background-color: transparent;
    }

    .staking_info_section {
        margin: 40px 0px 40px;
        text-align: center;
    }

    .staking_info_card h3 {
        font-size: 16px;
        margin-top: 15px;
    }

    .staking_info_icon {
        width: 54px;
        height: 54px;
        margin: 0 auto;
    }

    .staking_info_card {
        border-radius: 0px;
        padding: 0px;
    }

    .staking_info_card p {
        font-size: 13px;
    }

    .nextarrow_step {
        display: none;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/SoftStaking/staking.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,OAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;;;AAIA,wCAAwC;AACxC;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,cAAc;IACd,eAAe;IACf,oCAAoC;;AAExC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,oBAAoB;QACpB,mBAAmB;IACvB;;;IAGA;QACI,cAAc;IAClB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,mDAAmD;IACnD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gCAAgC;QAChC,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,uCAAuC;IAC3C;;IAEA;QACI,qBAAqB;IACzB;;;AAGJ;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,OAAO;IACP,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,mDAAmD;IACnD,aAAa;IACb,kCAA0B;YAA1B,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAO;IACP,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,UAAU;IACV,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;;+DAE+D;AAC/D;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,UAAU;IACV,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;+DAE+D;AAC/D;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,SAAO;IACP,2BAA2B;IAC3B,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA,8BAA8B;AAC9B;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;;AAGA;;IAEI;QACI,eAAe;IACnB;;;AAGJ;;;AAGA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;;AAIA,kCAAkC;AAClC;;IAEI;;;;;;QAMI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,8BAA8B;QAC9B,aAAa;QACb,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,gCAAgC;QAChC,kCAA0B;gBAA1B,0BAA0B;QAC1B,2BAA2B;QAC3B,WAAW;QACX,4BAA4B;QAC5B,aAAa;QACb,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;QAC3B,yBAAyB;IAC7B;;IAEA;QACI;YACI,2BAA2B;QAC/B;;QAEA;YACI,wBAAwB;QAC5B;IACJ;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,gCAAgC;QAChC,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,+BAA+B;QAC/B,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,YAAY;QACZ,UAAU;QACV,UAAU;QACV,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,+BAA+B;QAC/B,6BAA6B;IACjC;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":[".staking_page_wrapper {\n    width: 100%;\n    padding: 60px 0px;\n    color: #e0e0e0;\n    background-color: #181a20;\n}\n\nbody.light_theme .staking_page_wrapper {\n    background-color: #fff;\n    color: #1a1a1a;\n}\n\n.staking_page_wrapper .container {\n    max-width: 1240px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.staking_bnr_cnt {\n    justify-content: space-between;\n    align-items: center;\n    gap: 32px;\n    margin-bottom: 60px;\n}\n\n.staking_title {\n    font-size: 48px;\n    font-weight: 700;\n    margin: 0;\n}\n\n\n.staking_page_wrapper .convert-page__faqSection {\n    padding: 0px 0px 50px;\n}\n\n.staking_page_wrapper p.staking_desc {\n    font-size: 18px;\n    color: #84888C;\n    font-weight: 500;\n    margin-top: 15px;\n}\n\n.staking_page_wrapper .staking_btn {\n    padding-top: 15px;\n}\n\n.staking_page_wrapper .staking_btn button {\n    font-size: 15px;\n    color: #ffffff;\n    background-color: #2b3138;\n    border-radius: 50px;\n    padding: 16px 24px;\n    font-weight: 500;\n    border: none;\n    cursor: pointer;\n}\n\nbody.light_theme .staking_page_wrapper .staking_btn button {\n    color: #070808;\n    background-color: #F5F6F7;\n}\n\n.staking_page_wrapper .staking_btn button.loginbtn {\n    background-color: #303236;\n    color: #fff;\n}\n\n.staking_img {\n    max-width: 450px;\n}\n\n.staking_info_section {\n    margin: 100px 0px 70px;\n}\n\n.staking_info_title {\n    font-size: 28px;\n    font-weight: 600;\n    margin-bottom: 32px;\n    color: #e6e6e6;\n}\n\nbody.light_theme .staking_info_title {\n    color: #070808;\n}\n\n.staking_info_cards {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    padding-top: 25px;\n}\n\n.staking_info_card {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding-left: 85px;\n}\n\n.staking_info_icon {\n    width: 80px;\n    height: 80px;\n    border: 1px solid #EFDEC2;\n    margin-bottom: 24px;\n    border-radius: 50%;\n    box-shadow: 0px 1px 10px #0000001c;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.staking_info_card .number {\n    font-size: 60px;\n    color: #F3EBDF;\n    font-weight: 700;\n    position: absolute;\n    left: 0px;\n}\n\n.staking_info_icon img {\n    object-fit: contain;\n}\n\n.staking_info_card h3 {\n    font-size: 20px;\n    font-weight: 600;\n    color: #e1e1e1;\n    margin: 0 0 12px 0;\n}\n\nbody.light_theme .staking_info_card h3 {\n    color: #111;\n}\n\n.staking_info_card p {\n    font-size: 16px;\n    color: #84888C;\n    line-height: 1.5;\n    margin: 0;\n}\n\n.nextarrow_step {\n    font-size: 36px;\n    color: #E5E7EB;\n    position: absolute;\n    right: -20px;\n    font-weight: 200;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    z-index: 10;\n}\n\n.staking_products_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n}\n\n.staking_products_header h2 {\n    font-size: 28px;\n    font-weight: 700;\n    margin: 0;\n    color: #e7e7e7;\n}\n\nbody.light_theme .staking_products_header h2 {\n    color: #111;\n}\n\n.staking_products_filters {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.staking_checkbox_label {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n    color: #dbdbdb;\n    cursor: pointer;\n}\n\nbody.light_theme .staking_checkbox_label {\n    color: #070808;\n}\n\n.staking_checkbox_label input {\n    width: 16px;\n    height: 16px;\n    accent-color: #333;\n    cursor: pointer;\n}\n\n.staking_search_bar {\n    display: flex;\n    align-items: center;\n    background-color: #f6f6f724;\n    border-radius: 6px;\n    padding: 8px 16px;\n    gap: 10px;\n    width: 240px;\n}\n\nbody.light_theme .staking_search_bar {\n    background-color: #F6F6F7;\n}\n\n.staking_search_bar input {\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 14px;\n    width: 100%;\n    color: #dadada;\n}\n\nbody.light_theme .staking_search_bar input {\n    color: #111;\n}\n\n.staking_search_bar input::placeholder {\n    color: #a0a5aa;\n}\n\n.staking_table_container {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.staking_table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n}\n\n.staking_table th {\n    padding: 16px;\n    color: #848e9c;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.staking_table th .sort_icon {\n    font-size: 10px;\n    margin-left: 4px;\n    color: #a0a5aa;\n}\n\n.staking_table td {\n    padding: 24px 16px;\n    /* border-bottom: 1px solid #f5f6f7; */\n    font-size: 16px;\n    font-weight: 500;\n    color: #e0e0e0;\n}\n\nbody.light_theme .staking_table td {\n    color: #1e2329;\n}\n\n.staking_table .action_th,\n.staking_table .action_td {\n    text-align: right;\n    width: auto;\n    float: right;\n}\n\n.coin_cell {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.coin_icon_stak {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.staking_page_wrapper .coin_name {\n    font-weight: 500;\n    color: #ececec;\n    font-size: 16px;\n}\n\nbody.light_theme .staking_page_wrapper .coin_name {\n    color: #070808;\n}\n\n.staking_page_wrapper .coin_badge {\n    font-size: 11px;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-weight: 600;\n}\n\n.badge_bonus {\n    background-color: #8FFCDE;\n    color: #000000;\n}\n\n.badge_vip {\n    background-color: #FFD98F;\n    color: #000000;\n}\n\n.badge_new {\n    background-color: #52FFB1;\n    color: #000000;\n}\n\n.fire_icon {\n    font-size: 14px;\n}\n\n.apr_cell {\n    font-weight: 600;\n    color: #1e2329;\n}\n\n.reward_icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: bold;\n    font-size: 10px;\n}\n\n.multiple_rewards {\n    display: flex;\n    align-items: center;\n}\n\n.multiple_rewards .reward_icon {\n    margin-left: -8px;\n    border: 2px solid white;\n}\n\n.multiple_rewards .reward_icon:first-child {\n    margin-left: 0;\n}\n\n.type_cell {\n    font-weight: 600;\n    color: #4b4f56;\n}\n\n.action_btn {\n    background-color: #2b3139;\n    color: white;\n    border: none;\n    padding: 8px 24px;\n    border-radius: 20px;\n    font-weight: 500;\n    font-size: 13px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.action_btn:hover {\n    background-color: #1e2329;\n}\n\n.mobile_action_btns {\n    display: none;\n}\n\n.staking_pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 40px;\n    gap: 8px;\n}\n\n.page_num,\n.page_nav {\n    background: none;\n    border: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #4b4f56;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.page_num:hover,\n.page_nav:hover {\n    background-color: #f5f6f7;\n}\n\n.page_num.active {\n    background-color: #f5f6f7;\n    color: #111;\n}\n\n/* Why Stake Section */\n.why_stake_section_new {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 100px 0px;\n}\n\n.why_stake_left {\n    flex: 1;\n}\n\n.why_stake_right {\n    flex: 1 1;\n    display: flex;\n    justify-content: end;\n    align-items: center;\n}\n\n.why_stake_right img {\n    max-width: 240px;\n}\n\n.why_stake_cards {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 30px;\n}\n\n.why_stake_card {\n    display: flex;\n    align-items: center;\n    background-color: #fafafa0d;\n    border: 1px solid #f3f4f60d;\n    padding: 30px;\n    position: relative;\n    border-radius: 14px;\n}\n\nbody.light_theme .why_stake_card {\n    background-color: #fafafa;\n    border: 1px solid #F3F4F6;\n}\n\n.why_stake_card::before {\n    content: \"\";\n    width: 3px;\n    height: 30px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0px;\n    left: 0;\n    background-color: #C59D5F;\n    border-radius: 2px;\n    z-index: 999;\n}\n\nbody.light_theme .why_stake_card_icon {\n    border: 1px solid #F3F4F6;\n    background-color: white;\n}\n\n.why_stake_card_icon {\n    width: 50px;\n    height: 50px;\n    border: 1px solid #505050;\n    min-width: 50px;\n    background-color: #393939;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 20px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.why_stake_card_icon img {\n    width: 28px;\n    height: 28px;\n    object-fit: contain;\n}\n\n.why_stake_card_content h3 {\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0 0 5px 0;\n}\n\n.why_stake_card_content p {\n    font-size: 13px;\n    color: #84888C;\n    margin: 0;\n}\n\n/* How to Stake Section */\n.how_stake_section {\n    margin-bottom: 100px;\n}\n\n.how_stake_timeline {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    margin-top: 60px;\n    gap: 32px;\n}\n\n.timeline_line {\n    position: absolute;\n    top: 40px;\n    left: 10%;\n    right: 10%;\n    height: 1px;\n    border-top: 1px dashed #eaecef;\n    background-color: transparent;\n    z-index: 1;\n}\n\n.timeline_step {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    position: relative;\n    z-index: 2;\n}\n\n.step_icon_container {\n    position: relative;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.step_icon {\n    width: 94px;\n    border: 1px solid #c4c6cf42;\n    height: 94px;\n    background-color: #171a20;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .step_icon {\n    background-color: white;\n}\n\n.step_icon img {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n}\n\n.step_number {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background-color: #171a20;\n    color: #e4e4e4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 600;\n    font-size: 12px;\n    position: absolute;\n    top: -8px;\n    border: 1px solid #C4C6CF30;\n}\n\nbody.light_theme .step_number {\n\n    background-color: #F7F9FB;\n    color: #292b2f;\n}\n\n.timeline_step h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n}\n\n.timeline_step p {\n    font-size: 13px;\n    color: #84888C;\n    margin: 0;\n    max-width: 370px;\n}\n\n\n\n/* Staking Detail / Help Center Layout */\n.staking_detail_wrapper {\n    width: 100%;\n    padding: 40px 0;\n    color: #f1f1f1;\n    background-color: #181a20;\n    min-height: 80vh;\n}\n\nbody.light_theme .staking_detail_wrapper {\n    color: #111;\n    background-color: #fff;\n}\n\n.staking_detail_wrapper .container {\n    max-width: 1240px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.hc_breadcrumb {\n    font-size: 16px;\n    color: #A0A3A7;\n    margin-bottom: 40px;\n}\n\n.hc_breadcrumb .hc_link {\n    cursor: pointer;\n}\n\n.hc_breadcrumb .hc_link:hover {\n    opacity: 0.8;\n}\n\n.hc_breadcrumb .hc_sep {\n    margin: 0 8px;\n    font-size: 12px;\n}\n\n.hc_breadcrumb .hc_current {\n    color: #ffffff;\n    font-weight: 500;\n}\n\nbody.light_theme .hc_breadcrumb .hc_current {\n    color: #111;\n}\n\n.hc_layout {\n    display: flex;\n    gap: 40px;\n}\n\n.hc_sidebar {\n    width: 260px;\n    flex-shrink: 0;\n    border-right: 1px solid #f2f3f42e;\n    padding-right: 40px;\n}\n\nbody.light_theme .hc_sidebar {\n    border-right: 1px solid #F2F3F4;\n}\n\n.hc_mobile_toggle {\n    display: none;\n}\n\n.hc_sidebar_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 0;\n    font-size: 16px;\n    color: #e7e7e7;\n    cursor: pointer;\n    border-bottom: 1px solid transparent;\n\n}\n\nbody.light_theme .hc_sidebar_item {\n    color: #484B51;\n}\n\n.hc_sidebar_item:hover {\n    opacity: 0.8;\n}\n\n.hc_sidebar_item .font-weight-bold {\n    font-weight: 600;\n}\n\n.hc_sidebar_item .text-black {\n    color: #111;\n}\n\n.hc_chev {\n    color: #848e9c;\n    transition: transform 0.2s ease;\n    transform: rotate(0deg);\n}\n\n.hc_chev.open {\n    transform: rotate(90deg);\n}\n\n.hc_submenu {\n    padding-left: 20px;\n    margin-top: 8px;\n    margin-bottom: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.hc_submenu_item {\n    font-size: 16px;\n    color: #e9e9e9;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\nbody.light_theme .hc_submenu_item {\n    color: #484B51;\n}\n\n.hc_submenu_item:hover {\n    opacity: 0.8;\n}\n\n.hc_submenu_item.active_sub {\n    font-weight: 600;\n    color: #dddddd;\n}\n\n.hc_submenu_item.active_sub:hover {\n    opacity: 0.8;\n}\n\n.hc_main_content {\n    flex-grow: 1;\n}\n\n.hc_content_section {\n    margin-bottom: 18px;\n}\n\n.hc_section_header {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n    padding-bottom: 16px;\n    cursor: pointer;\n}\n\n.hc_section_header h2 {\n    font-size: 19px;\n    font-weight: 600;\n    margin: 0;\n    color: #e7e7e7;\n}\n\nbody.light_theme .hc_section_header h2 {\n    color: #111;\n}\n\n.hc_section_chev {\n    color: #e7e7e7;\n    transition: transform 0.2s ease;\n    transform: rotate(90deg);\n}\n\nbody.light_theme .hc_section_chev {\n    color: #111;\n}\n\n.hc_section_chev.open {\n    transform: rotate(-90deg);\n}\n\n.hc_article_grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px 40px;\n    padding-bottom: 24px;\n}\n\n.hc_article_item {\n    font-size: 16px;\n    line-height: 1.5;\n}\n\n.hc_article_item a {\n    color: #b3b3b3;\n    text-decoration: none;\n    transition: color 0.2s;\n}\n\nbody.light_theme .hc_article_item a {\n    color: #4b4f56;\n}\n\n.hc_article_item a:hover {\n    opacity: 0.8;\n}\n\n@media (max-width: 767px) {\n    .hc_layout {\n        flex-direction: column;\n        gap: 30px;\n    }\n\n    .hc_mobile_toggle {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 12px;\n        background: #393c42;\n        border-radius: 8px;\n        margin-bottom: 0px;\n        cursor: pointer;\n    }\n\n    body.light_theme .hc_mobile_toggle {\n        background: #f8f9fa;\n    }\n\n    .hc_mobile_toggle h2 {\n        font-size: 16px;\n        font-weight: 600;\n        margin: 0;\n        color: #e3e3e3;\n    }\n\n    body.light_theme .hc_mobile_toggle h2 {\n        color: #111;\n    }\n\n    .hc_section_header h2 {\n        font-size: 16px;\n    }\n\n    .hc_article_item {\n        font-size: 14px;\n    }\n\n    .hc_sidebar {\n        display: none;\n        width: 100%;\n        border-right: none;\n        border-bottom: none;\n        padding-right: 0;\n        padding-bottom: 20px;\n        margin-bottom: 20px;\n    }\n\n\n    .hc_sidebar.mobile_open {\n        display: block;\n    }\n\n    .hc_article_grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Mint Modal styling */\n.mint-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    backdrop-filter: blur(5px);\n    height: 100vh;\n    background-color: rgb(255 255 255 / 20%) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 99999999;\n    animation: fadeInModal 0.25s ease-out;\n}\n\n.mint-modal-content {\n    background-color: #ffffffde !important;\n    color: #1e2329 !important;\n    width: 95%;\n    max-width: 800px;\n    border-radius: 12px;\n    padding: 24px 32px;\n    position: relative;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.20);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\n.mint-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.mint-modal-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.mint-title-icon {\n    width: 24px;\n    height: 24px;\n}\n\n.mint-modal-close {\n    background: transparent;\n    border: none;\n    padding: 0px;\n    font-size: 24px;\n    color: #ffffff !important;\n    cursor: pointer;\n    transition: color 0.2s;\n    line-height: 1;\n}\n\nbody.light_theme .mint-modal-close {\n    color: #1e2329 !important;\n}\n\n.mint-modal-body {\n    display: flex;\n    gap: 40px;\n}\n\n/* Left Column */\n.mint-modal-left {\n    flex: 1;\n}\n\n.mint-info-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 24px;\n}\n\n.mint-info-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.mint-info-label {\n    font-size: 13px;\n    color: #848e9c !important;\n    font-weight: 500;\n}\n\n.mint-info-value {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1e2329 !important;\n}\n\n.mint-green-text {\n    color: #03a66d !important;\n}\n\n.mint-section-label {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 12px;\n}\n\n.mint-input-box {\n    display: flex;\n    align-items: center;\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    padding: 10px 16px;\n    transition: border-color 0.2s;\n}\n\n.mint-input-box:focus-within {\n    border-color: #1a1d21;\n}\n\n.mint-input-box input {\n    flex: 1;\n    border: none;\n    outline: none;\n    font-size: 14px;\n    color: #1e2329 !important;\n}\n\n.mint-input-addon {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.mint-max-btn {\n    color: #d1aa67 !important;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.mint-currency-dropdown {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.mint-amount-details {\n    margin-top: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 32px;\n}\n\n.mint-amount-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n}\n\n.mint-amount-lbl {\n    color: #848e9c !important;\n}\n\n.mint-amount-val {\n    color: #1e2329 !important;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.mint-add-icon {\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.mint-apr-box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    padding: 16px;\n    font-size: 14px;\n    color: #848e9c !important;\n}\n\n.mint-apr-box span:last-child {\n    font-weight: 600;\n    color: #1e2329 !important;\n}\n\n/* Right Column */\n.mint-modal-right {\n    flex: 1;\n}\n\n.mint-daily-return-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 8px;\n}\n\n.mint-daily-return-box {\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 32px;\n}\n\n.mint-return-icon {\n    width: 20px;\n    height: 20px;\n}\n\n.mint-return-val {\n    font-size: 14px;\n    font-weight: 600;\n    color: #12a771 !important;\n}\n\n.mint-rules-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    border-bottom: 1px solid #eaecef;\n    padding-bottom: 8px;\n}\n\n.mint-rules-title {\n    font-size: 14px;\n    font-weight: 600;\n    position: relative;\n}\n\n.mint-title-underline {\n    position: absolute;\n    bottom: -9px;\n    left: 0;\n    width: 20px;\n    height: 3px;\n    background-color: #1e2329;\n    border-radius: 2px;\n}\n\n.mint-rules-link {\n    font-size: 13px;\n    color: #848e9c !important;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n}\n\n.mint-timeline {\n    position: relative;\n    padding-left: 12px;\n}\n\n.mint-timeline::before {\n    content: '';\n    position: absolute;\n    top: 6px;\n    bottom: 20px;\n    left: 14px;\n    width: 1px;\n    background-color: #eaecef;\n}\n\n.mint-timeline-item {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 20px;\n    position: relative;\n}\n\n.mint-timeline-item.last {\n    margin-bottom: 0;\n}\n\n.mint-timeline-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #eaecef;\n    margin-top: 6px;\n    margin-right: 16px;\n    position: relative;\n    z-index: 2;\n}\n\n.mint-timeline-dot.active {\n    background-color: #1e2329;\n}\n\n.mint-timeline-dot.icon {\n    background-color: transparent;\n    margin-top: 2px;\n    margin-left: -3px;\n    font-size: 14px;\n    color: #848e9c;\n}\n\n.mint-timeline-content {\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    font-size: 13px;\n}\n\n.mint-timeline-lbl {\n    color: #1e2329 !important;\n}\n\n.mint-timeline-val {\n    color: #848e9c !important;\n    text-align: right;\n}\n\n.mint-timeline-val.multi-line {\n    line-height: 1.4;\n}\n\n/* Footer */\n.mint-modal-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 40px;\n}\n\n.mint-agreement {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n}\n\n.mint-agreement input {\n    cursor: pointer;\n}\n\n.mint-agreement label {\n    color: #1e2329 !important;\n}\n\n.mint-agreement a {\n    color: #1e2329 !important;\n    text-decoration: underline;\n}\n\n.mint-actions {\n    display: flex;\n    gap: 12px;\n}\n\n.mint-btn-cancel {\n    background-color: #f5f6f7;\n    color: #1e2329 !important;\n    border: none;\n    border-radius: 8px;\n    padding: 10px 24px;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.mint-btn-confirm {\n    background-color: #f5f6f7;\n    color: #b7bdc6 !important;\n    border: none;\n    border-radius: 8px;\n    padding: 10px 24px;\n    font-weight: 600;\n    cursor: not-allowed;\n    font-size: 14px;\n}\n\n.mint-btn-confirm:not(:disabled) {\n    background-color: #1a1d21;\n    color: #f3f3f3 !important;\n    cursor: pointer;\n}\n\n@media (max-width: 767px) {\n    .mint-modal-body {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .mint-modal-footer {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 20px;\n    }\n\n    .mint-actions {\n        flex-direction: column;\n    }\n\n    .mint-btn-cancel,\n    .mint-btn-confirm {\n        width: 100%;\n    }\n\n    .mint-modal-overlay {\n        align-items: end;\n    }\n\n    .mint-modal-content {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 12px 12px 0px 0px;\n        max-height: 85vh;\n        height: auto;\n        min-height: 30vh;\n        overflow: scroll;\n        padding: 20px;\n        box-shadow: 0 4px 24px rgb(0 0 0 / 39%);\n    }\n\n    .staking_page_wrapper .convert-page__faqSection {\n        padding: 0px 0px 20px;\n    }\n\n\n}\n\n/* Tooltip styles */\n.mint-tooltip-wrapper {\n    position: relative;\n    display: inline-block;\n    cursor: help;\n    border-bottom: 1px dotted #848e9c;\n}\n\n.mint-tooltip {\n    visibility: hidden;\n    opacity: 0;\n    width: 320px;\n    background-color: #2b3139;\n    color: #eaecef;\n    text-align: left;\n    border-radius: 6px;\n    padding: 12px 16px;\n    position: absolute;\n    z-index: 1000;\n    top: 100%;\n    left: 0;\n    margin-top: 8px;\n    font-size: 13px;\n    line-height: 1.5;\n    transition: opacity 0.2s, visibility 0.2s;\n    font-weight: 400;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    pointer-events: none;\n}\n\n.mint-tooltip::after {\n    content: \"\";\n    position: absolute;\n    bottom: 100%;\n    left: 20px;\n    border-width: 6px;\n    border-style: solid;\n    border-color: transparent transparent #2b3139 transparent;\n}\n\n.mint-tooltip-wrapper:hover .mint-tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Intro Modal Styling */\n.intro-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgb(255 255 255 / 20%) !important;\n    display: flex;\n    backdrop-filter: blur(5px);\n    justify-content: center;\n    align-items: center;\n    z-index: 100000000;\n    animation: fadeInModal 0.25s ease-out;\n}\n\n.intro-modal-content {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n    width: 95%;\n    max-width: 600px;\n    border-radius: 12px;\n    padding: 24px;\n    position: relative;\n    box-shadow: 0 4px 24px rgb(0 0 0 / 26%);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\n.intro-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.intro-modal-header h2 {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0;\n    flex: 1;\n    margin-left: 8px;\n}\n\n.intro-back-btn,\n.intro-close-btn {\n    background: transparent;\n    border: none;\n    font-size: 20px;\n    color: #848e9c !important;\n    cursor: pointer;\n    line-height: 1;\n    padding: 0;\n}\n\n.intro-back-btn:hover,\n.intro-close-btn:hover {\n    color: #1e2329 !important;\n}\n\n.intro-back-btn {\n    font-size: 24px;\n    color: #1e2329 !important;\n}\n\n.intro-tabs {\n    display: flex;\n    gap: 24px;\n    border-bottom: 1px solid #eaecef;\n    margin-bottom: 24px;\n}\n\n.intro-tab {\n    font-size: 14px;\n    font-weight: 600;\n    color: #848e9c !important;\n    padding-bottom: 12px;\n    cursor: default;\n    position: relative;\n}\n\n.intro-tab.active {\n    color: #1e2329 !important;\n}\n\n.intro-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: #1e2329;\n    border-radius: 2px;\n}\n\n.intro-rule-section {\n    margin-bottom: 24px;\n}\n\n.intro-rule-section h4 {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n    color: #1e2329 !important;\n}\n\n.intro-rule-section p {\n    font-size: 13px;\n    line-height: 1.6;\n    color: #848e9c !important;\n    margin: 0 0 8px 0;\n}\n\n/* Service Fee Dropdown */\n.service-fee-container {\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    margin-top: 12px;\n    background-color: #ffffff;\n    overflow: hidden;\n}\n\n.service-fee-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #848e9c;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 12px;\n    cursor: pointer;\n}\n\n.service-fee-value {\n    color: #1e2329;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.service-fee-body {\n    padding: 0 12px 12px 12px;\n}\n\n.service-fee-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #848e9c;\n    font-size: 13px;\n    margin-bottom: 8px;\n}\n\n.service-fee-row:last-child {\n    margin-bottom: 0;\n}\n\n/* Tiers Timeline inside APR */\n.tier-timeline {\n    position: relative;\n    padding-left: 6px;\n    margin-top: 8px;\n}\n\n.tier-timeline::before {\n    content: '';\n    position: absolute;\n    top: 8px;\n    bottom: 12px;\n    left: 12px;\n    width: 1px;\n    background-color: #eaecef;\n    z-index: 1;\n}\n\n.tier-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #1e2329;\n    font-size: 13px;\n    margin-bottom: 12px;\n    position: relative;\n    z-index: 2;\n}\n\n.tier-item:last-child {\n    margin-bottom: 0;\n}\n\n.tier-item-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #ffffff;\n}\n\n.tier-item-left i {\n    color: #848e9c;\n    font-size: 16px;\n}\n\n/* ==========================================================\n   Staking Page Projects Tabs (Launchpad style)\n   ========================================================== */\n.launchpad_projects_tabs {\n    display: flex;\n    gap: 32px;\n    margin-bottom: 20px;\n}\n\n.projects_tab {\n    background: transparent;\n    border: none;\n    padding: 0 0 12px 0;\n    font-size: 20px;\n    font-weight: 600;\n    color: #84888C;\n    cursor: pointer;\n    position: relative;\n    transition: color 0.2s;\n}\n\n.projects_tab:hover {\n    opacity: 0.8;\n}\n\n.projects_tab.active {\n    color: #ffffff;\n    font-weight: 600;\n}\n\nbody.light_theme .projects_tab.active {\n    color: #1E2329;\n}\n\n.projects_tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    right: 0px;\n    margin: 0 auto;\n    width: 50%;\n    height: 3px;\n    background-color: #D4B363;\n}\n\n@media (max-width: 767px) {\n\n    .projects_tab {\n        font-size: 15px;\n    }\n\n    .pool_card {\n        padding: 20px;\n    }\n\n    .why_stake_card {\n        padding: 20px;\n    }\n\n    .how_stake_section {\n        margin-bottom: 50px;\n    }\n\n    .staking_page_wrapper .staking_btn button {\n        font-size: 13px;\n        padding: 8px 16px;\n    }\n\n    .launchpad_projects_tabs {\n        gap: 20px;\n        margin-bottom: 0px;\n    }\n\n    .project_name_badge h3 {\n        font-size: 20px;\n    }\n}\n\n/* ==========================================================\n   Project Card Layout Styles (Launchpad Style)\n   ========================================================== */\n.project_card {\n    background-color: #f9fafb0d;\n    border-radius: 20px;\n    padding: 24px;\n    position: relative;\n    margin-bottom: 24px;\n}\n\nbody.light_theme .project_card {\n    background-color: #F9FAFB;\n}\n\n.project_card_status {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: #EBECED;\n    color: #84888C;\n    font-size: 13px;\n    font-weight: 400;\n    padding: 1px 12px;\n    border-top-right-radius: 20px;\n    border-bottom-left-radius: 12px;\n}\n\n.project_card_inner {\n    display: flex;\n    gap: 30px;\n}\n\n.project_card_left {\n    width: 320px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    padding-top: 10px;\n    cursor: pointer;\n    transition: transform 0.2s;\n}\n\n.project_card_left:hover {\n    transform: translateY(-2px);\n}\n\n.project_title_sec {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 30px;\n}\n\n.project_icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background-color: #1E2329;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.project_icon img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.project_name_badge h3 {\n    font-size: 23px;\n    font-weight: 600;\n    color: #fff;\n    margin: 0;\n}\n\nbody.light_theme .project_name_badge h3 {\n    color: #000;\n}\n\n.initial_badge {\n    display: inline-block;\n    background-color: #89EFF6;\n    color: #000000;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 4px;\n    margin-top: 4px;\n}\n\n.project_info_group {\n    margin-bottom: 24px;\n}\n\n.project_info_group.mt-auto {\n    margin-top: auto;\n    margin-bottom: 0;\n}\n\n.info_label {\n    color: #f0f0f0;\n    font-size: 12px;\n    margin-bottom: 1px;\n}\n\nbody.light_theme .info_label {\n    color: #84888C;\n}\n\n.info_value p {\n    color: #e8e8e8;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 4px;\n}\n\nbody.light_theme .info_value p {\n    color: #1E2329;\n}\n\n.project_card_right {\n    flex-grow: 1;\n    display: flex;\n    gap: 20px;\n}\n\n.pool_card {\n    background-color: #ffffff12;\n    border-radius: 16px;\n    border: 1px solid #eaecef1f;\n    padding: 24px;\n    color: #fff;\n    flex: 1;\n    max-width: calc(50% - 10px);\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\nbody.light_theme .pool_card {\n    background-color: #FFFFFF;\n    color: #1a1a1a;\n    border: 1px solid #eaecef;\n}\n\n.pool_card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);\n}\n\n.pool_card:only-child {\n    max-width: 50%;\n}\n\n.pool_title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 24px;\n}\n\n.pool_icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.pool_icon img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.pool_title h4 {\n    font-size: 19px;\n    font-weight: 600;\n    color: #fff;\n    margin: 0;\n}\n\nbody.light_theme .pool_title h4 {\n    color: #000;\n}\n\n.pool_stats_row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.stat_label {\n    color: #84888C;\n    font-size: 12px;\n    margin-bottom: 1px;\n}\n\n.stat_value {\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0;\n}\n\nbody.light_theme .stat_value {\n    color: #1E2329;\n}\n\n.stat_value span {\n    font-size: 14px;\n    font-weight: 600;\n    margin-left: 4px;\n}\n\n.pool_summary {\n    border-top: 1px solid #F2F3F4;\n    padding-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\nbody:not(.light_theme) .pool_summary {\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.summary_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.summary_label {\n    color: #84888C;\n    font-size: 12px;\n    margin: 0;\n}\n\n.summary_value {\n    font-size: 12px;\n    font-weight: 600;\n    margin: 0;\n    color: #fff;\n}\n\nbody.light_theme .summary_value {\n    color: #444444;\n}\n\n.trade_btn {\n    width: 100%;\n    margin-top: 24px;\n    background-color: #F5F6F7;\n    color: #1E2329;\n    font-size: 14px;\n    font-weight: 500;\n    border: none;\n    border-radius: 8px;\n    padding: 12px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.trade_btn:hover {\n    background-color: #EAECEF;\n}\n\n@media (max-width: 1024px) {\n    .project_card_inner {\n        flex-direction: column;\n    }\n\n    .project_card_left {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .project_card_right {\n        flex-direction: column;\n    }\n\n    .pool_card,\n    .pool_card:only-child {\n        max-width: 100%;\n    }\n}\n\n/* Soft Staking Modal Styles */\n.ss-modal-content {\n    max-width: 440px !important;\n}\n\n.ss-modal-body {\n    flex-direction: column;\n    gap: 16px;\n    padding: 10px 0px;\n}\n\n.ss-status-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.ss-status-label {\n    font-size: 15px;\n    font-weight: 600;\n    color: #eaecef;\n}\n\nbody.light_theme .ss-status-label {\n    color: #1e2329;\n}\n\n.ss-status-badge {\n    font-size: 12px;\n    font-weight: 600;\n    border-radius: 4px;\n    padding: 3px 10px;\n}\n\n.ss-status-badge--enabled {\n    color: #03a66d;\n    background: rgba(3, 166, 109, 0.18);\n}\n\n.ss-status-badge--disabled {\n    color: #848e9c;\n    background: rgba(132, 142, 156, 0.15);\n}\n\n.ss-desc {\n    font-size: 13px;\n    color: #848e9c;\n    margin: 0;\n    line-height: 1.6;\n}\n\n.ss-error {\n    color: #f6465d;\n    font-size: 13px;\n}\n\n.ss-btn-disable {\n    background-color: #f6465d !important;\n    border-color: #f6465d !important;\n    color: #fff !important;\n}\n\n/* Soft Staking Success Modal */\n.ss-success-modal {\n    max-width: 400px;\n}\n\n.ss-success-content {\n    padding: 32px 24px;\n    text-align: center;\n}\n\n.ss-success-icon {\n    font-size: 56px;\n    line-height: 1;\n}\n\n.ss-success-icon.active {\n    color: #03a66d;\n}\n\n.ss-success-icon.inactive {\n    color: #848e9c;\n}\n\n.ss-success-title {\n    margin: 16px 0 8px;\n    font-size: 18px;\n    font-weight: 700;\n    color: #e0e0e0;\n}\n\nbody.light_theme .ss-success-title {\n    color: #1e2329;\n}\n\n.ss-success-desc {\n    font-size: 13px;\n    color: #848e9c;\n    margin: 0 0 24px;\n    line-height: 1.6;\n}\n\n.ss-success-btn {\n    width: 100%;\n}\n\n\n@media (max-width: 1366px) {\n\n    .staking_title {\n        font-size: 38px;\n    }\n\n\n}\n\n\n@media (max-width: 1200px) {\n\n    .staking_title {\n        font-size: 32px;\n    }\n\n    .staking_img {\n        max-width: 300px;\n    }\n\n\n    .staking_page_wrapper .staking_btn button {\n        font-size: 14px;\n        padding: 10px 20px;\n    }\n\n    .why_stake_card_content h3 {\n        font-size: 18px;\n    }\n\n    .staking_info_title {\n        font-size: 24px;\n    }\n\n}\n\n@media (max-width: 991px) {\n\n    .staking_info_card .number {\n        font-size: 40px;\n    }\n\n    .projects_tab {\n        font-size: 16px;\n    }\n\n    .staking_info_card {\n        padding-left: 65px;\n    }\n\n    .staking_info_card h3 {\n        font-size: 18px;\n    }\n\n    .staking_info_card p {\n        font-size: 14px;\n    }\n\n}\n\n\n\n/* Mobile Table and Popup styles */\n@media (max-width: 767px) {\n\n    .staking_table th:nth-child(3),\n    .staking_table th:nth-child(4),\n    .staking_table th:nth-child(5),\n    .staking_table td:nth-child(3),\n    .staking_table td:nth-child(4),\n    .staking_table td:nth-child(5) {\n        display: none;\n    }\n\n    .why_stake_section_new {\n        margin: 40px 0px;\n    }\n\n    .staking_table th:nth-child(2),\n    .staking_table td:nth-child(2) {\n        text-align: right;\n    }\n\n    .staking_table th:nth-child(1),\n    .staking_table td:nth-child(1) {\n        padding-left: 10px;\n    }\n\n    .staking_table tbody tr {\n        cursor: pointer;\n    }\n\n    .projects_tab {\n        font-size: 14px;\n    }\n\n    .project_card {\n        padding: 20px;\n    }\n\n    .project_name_badge h3 {\n        font-size: 19px;\n    }\n\n    .project_icon {\n        width: 32px;\n        min-width: 32px;\n        height: 32px;\n    }\n\n    .project_title_sec {\n        margin-bottom: 20px;\n    }\n\n    .project_info_group {\n        margin-bottom: 15px;\n    }\n\n    .mobile_staking_popup_overlay {\n        position: fixed;\n        inset: 0;\n        background: rgba(0, 0, 0, 0.4);\n        z-index: 1000;\n        display: flex;\n        align-items: flex-end;\n    }\n\n    .mobile_staking_popup {\n        background: #1e232994 !important;\n        backdrop-filter: blur(4px);\n        border: 1px solid #ffffff12;\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        padding: 20px;\n        animation: slideUp 0.3s ease;\n    }\n\n    body.light_theme .mobile_staking_popup {\n        background: #fff !important;\n        color: #080808 !important;\n    }\n\n    @keyframes slideUp {\n        from {\n            transform: translateY(100%);\n        }\n\n        to {\n            transform: translateY(0);\n        }\n    }\n\n    .mobile_staking_popup .popup_header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 20px;\n    }\n\n    .mobile_staking_popup .popup_header h3 {\n        margin: 0;\n        font-size: 20px;\n        font-weight: 700;\n    }\n\n    .mobile_staking_popup .close_btn {\n        background: none;\n        border: none;\n        font-size: 28px;\n        color: #84888C;\n        cursor: pointer;\n    }\n\n    .mobile_staking_popup .popup_row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 15px 0;\n        border-bottom: 1px solid #f0f0f0;\n        font-size: 15px;\n    }\n\n    .mobile_staking_popup .popup_row:last-child {\n        border-bottom: none;\n    }\n\n    .mobile_staking_popup .popup_row span:first-child {\n        color: #84888C;\n    }\n\n    .mobile_staking_popup .apr_val {\n        color: #fff;\n        font-weight: 600;\n    }\n\n    body.light_theme .mobile_staking_popup .apr_val {\n        color: #111;\n    }\n\n    .reward_popup_icons {\n        display: flex;\n        gap: 6px;\n    }\n\n    .reward_popup_icon {\n        width: 24px;\n        height: 24px;\n    }\n\n    .mobile_staking_popup .popup_footer {\n        margin-top: 18px;\n    }\n\n    .mobile_staking_popup .popup_footer .action_btn {\n        font-size: 13px;\n        align-items: center;\n        justify-content: center;\n        border-radius: 8px;\n        padding: 8px !important;\n    }\n\n    .mobile_action_btns {\n        display: flex;\n        gap: 12px;\n        margin-bottom: 20px;\n    }\n\n    .softstakingsearch .searchBar.custom-tabs {\n        margin: 0px;\n    }\n\n}\n\n@media (max-width: 660px) {\n\n    .staking_bnr_cnt {\n        flex-direction: column;\n        gap: 32px;\n        margin-bottom: 40px;\n        text-align: center;\n    }\n\n    .staking_info_card .number {\n        display: none;\n    }\n\n    .staking_title {\n        font-size: 24px;\n    }\n\n    .staking_table td {\n        padding: 15px 10px;\n        font-size: 14px;\n    }\n\n    .staking_page_wrapper .coin_name {\n        font-size: 14px;\n    }\n\n    .staking_pagination {\n        margin-top: 20px;\n    }\n\n    .staking_page_wrapper p.staking_desc {\n        font-size: 15px;\n        margin-top: 10px;\n    }\n\n    .staking_img {\n        max-width: 240px;\n    }\n\n\n    .staking_page_wrapper {\n        padding: 50px 0px;\n    }\n\n    .staking_page_wrapper .staking_btn {\n        padding-top: 0px;\n        justify-content: center;\n    }\n\n    .staking_products_header h2 {\n        font-size: 20px;\n    }\n\n    .staking_products_header {\n        align-items: start;\n        margin-bottom: 20px;\n        gap: 20px;\n    }\n\n    .staking_info_cards {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 20px;\n    }\n\n    .staking_info_title {\n        font-size: 20px;\n        margin-bottom: 0px;\n        text-align: center;\n    }\n\n    .why_stake_section_new {\n        flex-direction: column;\n        margin-bottom: 50px;\n    }\n\n    .why_stake_right {\n        margin-top: 32px;\n    }\n\n    .why_stake_card_content h3 {\n        font-size: 16px;\n    }\n\n    .timeline_step {\n        display: grid;\n        grid-template-columns: 60px 1fr;\n        column-gap: 16px;\n        row-gap: 6px;\n        text-align: left;\n    }\n\n    .step_icon_container {\n        grid-column: 1;\n        grid-row: 1 / span 2;\n        margin: 0;\n        z-index: 2;\n    }\n\n    .step_icon {\n        width: 50px;\n        height: 50px;\n    }\n\n    .step_icon img {\n        width: 24px;\n        height: 24px;\n    }\n\n    .step_number {\n        width: 20px;\n        height: 20px;\n        font-size: 10px;\n        top: -6px;\n    }\n\n    .timeline_step h3 {\n        font-size: 16px;\n        margin: 0px;\n        align-self: end;\n    }\n\n    .timeline_step p {\n        max-width: 100%;\n        font-size: 13px;\n        align-self: start;\n        margin: 0;\n    }\n\n    .how_stake_section {\n        margin-bottom: 40px;\n    }\n\n    .how_stake_timeline {\n        display: flex;\n        flex-direction: column;\n        gap: 32px;\n        margin-top: 30px;\n        position: relative;\n    }\n\n    .timeline_line {\n        top: 20px;\n        bottom: 30px;\n        left: 25px;\n        width: 1px;\n        height: auto;\n        right: auto;\n        border-top: none;\n        border-left: 1px dashed #eaecef;\n        background-color: transparent;\n    }\n\n    .staking_info_section {\n        margin: 40px 0px 40px;\n        text-align: center;\n    }\n\n    .staking_info_card h3 {\n        font-size: 16px;\n        margin-top: 15px;\n    }\n\n    .staking_info_icon {\n        width: 54px;\n        height: 54px;\n        margin: 0 auto;\n    }\n\n    .staking_info_card {\n        border-radius: 0px;\n        padding: 0px;\n    }\n\n    .staking_info_card p {\n        font-size: 13px;\n    }\n\n    .nextarrow_step {\n        display: none;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
